export enum FieldTypes {
  String = 's',
  Number = 'n',
  Boolean = 'b',
  Date = 'd'
}
